import ApiService from "@/core/services/api.service";

export const tenantApi = {
    list: (data = null) => {
        const searchParams = new URLSearchParams();
        let params = data?data: {};
        Object.keys(params).forEach(key => searchParams.append(key, params[key]));
        return ApiService.get("admin/tenant/list?"+searchParams.toString());
    },

    getDataCsv:(data = null) => {
        const searchParams = new URLSearchParams();
        let params = data?data: {};
        Object.keys(params).forEach(key => searchParams.append(key, params[key]));
        return  ApiService.get("admin/tenant/export-excel?"+searchParams.toString());
    },

    detail: (id = null) => {
        return ApiService.get("admin/tenant/detail/"+id);
    },

    updateTenant: (data = null) => {
        return ApiService.put("admin/tenant/update", data);
    },

    addTenant: (data = null) => {
        return ApiService.post("admin/tenant/add-tenant", data);
    },

    allRole: () => {
        return ApiService.get("admin/role/all-role");
    },
    all: () => {
        return ApiService.get("admin/tenant/all");
    },
    checkTenantExits: (tenantDir) => {
        return ApiService.post("admin/tenant/check-exits", {'tenant_dir':tenantDir});
    }

}
